﻿import { createStore } from 'vuex';

const basicState = { component: null, props: {} };

export default createStore({
    state: {
        userManagementDictionary: {},
        claimDetailDictionary: {},
        modalState: basicState,
    },
    mutations: {
        setUserManagementDictionary(state, dictionary) {
            state.userManagementDictionary = dictionary;
        },
        setClaimDetailDictionary(state, dictionary) {
            state.claimDetailDictionary = dictionary;
        },
        openModal(state, payload) {
            state.modalState = { component: payload.component, props: payload.props || {} };
            const root = document.getElementsByTagName('html')[0];
            if (root) root.classList.add('is-clipped');
        },
        closeModal(state) {
            state.modalState = basicState;
            const body = document.body;
            const root = document.getElementsByTagName('html')[0];
            if (root) root.classList.remove('is-clipped');
        },
    },
    getters: {
        getUserManagementText: (state) => (key) => {
            return state.userManagementDictionary[key] || key;
        },
        getClaimDetailText: (state) => (key) => {
            return state.claimDetailDictionary[key] || key;
        },
        getModalComponent: (state) => {
            return state.modalState.component;
        },
        getModalProps: (state) => {
            return state.modalState.props;
        },
    },
});